module.exports = __webpack_public_path__ + "static/media/8791.fcb5e689.png";